import Text from "./Text";
import profileImg from "../assets/images/profile.jpg";
import { TiStarHalfOutline, TiStarFullOutline } from "react-icons/ti";

const SingleSessionCard = (props) => {
  const viewType = props.viewType;
  return (
    <div
      className={`single-session-wrapper last:mb-0 flex  mx-2 p-3  rounded-md bg-secondary-500 transition-all duration-300 hover:bg-secondary-600 ${
        viewType === "grid" ? "flex-col" : null
      }`}
    >
      <div className={`profile-img ${viewType == "list" ? "pr-4" : null}`}>
        <div className={`${viewType === "grid" ? "w-full" : "max-w-[170px]"}`}>
          <img src={profileImg} alt="" className="w-full" />
        </div>
      </div>
      <div
        className={`details flex-auto flex flex-wrap ${
          viewType === "grid" ? "flex-col" : null
        }`}
      >
        <div
          className={`pr-4 flex-auto pb-4 ${
            viewType === "grid" ? "pt-3" : null
          }`}
        >
          <div className="session-topic uppercase">Nutrition</div>
          <div className="session-title text-base text-black font-medium">
            <Text component={"h4"}>
              How to lower Cholesterol with your diet
            </Text>
          </div>
          <div className="dietitian-and-status">
            <Text component={"span"}>Ebru Bekiroğlu</Text>
            <span className="divider"> | </span>
            <span className="status text-green-700 font-medium">Online</span>
          </div>
          <div className="session-description">
            <Text>30 min session with Ebru</Text>
          </div>
          <div className="rate mt-4">
            <div className="stars flex text-xl text-black">
              <TiStarFullOutline className="" />
              <TiStarFullOutline />
              <TiStarFullOutline />
              <TiStarFullOutline />
              <TiStarHalfOutline />
            </div>
          </div>
        </div>
        <div className="price text-lg flex items-center text-[#e66553]">
          <Text component={"strong"} classes="font-medium">
            ₺29
          </Text>
        </div>
      </div>
    </div>
  );
};

export default SingleSessionCard;
